"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LeftArrow = function (_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? 'black' : _b, _c = _a.width, width = _c === void 0 ? 24 : _c, _d = _a.height, height = _d === void 0 ? 24 : _d;
    return (react_1.default.createElement("svg", { width: width, height: height, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 13 20' },
        react_1.default.createElement("defs", null),
        react_1.default.createElement("path", { className: 'leftArrow-path', fill: fillColor, fillRule: 'evenodd', d: 'M9.79 19.047L.5 10 9.79.953c.62-.604 1.625-.604 2.245 0 .62.604.62 1.582 0 2.187L4.99 10l7.045 6.862c.62.604.62 1.582 0 2.186-.62.603-1.625.603-2.245-.001z' })));
};
exports.default = LeftArrow;
